import { getPreviewLocation } from './utils';
import { IOS } from './constants';

export const getActivePushDeviceWrapperById = (state, { templateId }) =>
  state?.templatePreview?.[templateId]?.activePushDeviceWrapper || IOS;

export const getInAppDisplaySettingsById = (state, { templateId }) =>
  state.templatePreview[templateId]?.inAppDisplaySettings;

export const getInboxMetadataById = (state, { templateId }) =>
  state.templatePreview[templateId]?.inboxMetadata;

export const getIsLoading = (state) => state.templatePreview.isLoading;

export const getTemplatePreviewById = (
  state,
  { templateId, showAndroid, showExpanded, locale },
) => {
  const key = getPreviewLocation(showAndroid, showExpanded, locale);
  return state.templatePreview[templateId]?.[key];
};
